<mat-card>
	<mat-card-header>
		<mat-card-title>
			Resolve Provisional School
			<mat-icon *ngIf="isLoading">
				<mat-spinner diameter="20"></mat-spinner>
			</mat-icon>
			<button class="close-button" mat-mini-fab (click)="closeDialog(false)">
				<mat-icon>close</mat-icon>
			</button>
		</mat-card-title>
	</mat-card-header>

	<mat-card-content *ngIf="!isLoading">
		<div class="row">
			<div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6" *ngIf="!editingProvisionalSchoolInformation">
				<div class="d-flex justify-content-between align-items-center">
					<h2 class="mb-0">Provisional School Information</h2>

					<button mat-raised-button color="primary" (click)="toggleEdit(true)">
						<mat-icon>edit</mat-icon>
						Edit
					</button>
				</div>

				<mat-card-content>
					<table class="table table-default">
						<tbody>
							<tr>
								<td class="table-label" [ngClass]="{ danger: !provisionalSchool?.SCHOOL_NAME }">
									School Name
								</td>
								<td class="table-value">
									{{ provisionalSchool?.SCHOOL_NAME }}
								</td>
							</tr>

							<tr>
								<td class="table-label" [ngClass]="{ danger: !provisionalSchool?.DISTRICT }">
									School's District
								</td>
								<td class="table-value">
									{{ provisionalSchool?.DISTRICT }}
								</td>
							</tr>

							<tr>
								<td class="table-label">
									COE #
								</td>
								<td class="table-value">
									{{ provisionalSchool?.CO?.COE_NUMBER }}
								</td>
							</tr>

							<tr>
								<td class="table-label" [ngClass]="{
                      danger:
                        !provisionalSchool?.STREET_ADDRESS_1 &&
                        !provisionalSchool?.CITY &&
                        !provisionalSchool?.ZIPCODE
                    }">
									Address
								</td>
								<td class="table-value">
									{{ provisionalSchool?.STREET_ADDRESS_1 }}<br />

									<span *ngIf="provisionalSchool?.STREET_ADDRESS_2?.length > 0">
										{{ provisionalSchool.STREET_ADDRESS_2 }}<br />
									</span>

									{{ provisionalSchool?.CITY }}
									{{ provisionalSchool?.ZIPCODE }}
								</td>
							</tr>
						</tbody>
					</table>
				</mat-card-content>
			</div>


			<div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6" *ngIf="editingProvisionalSchoolInformation">
				<app-edit-provisional-school-information [(provisionalSchool)]="provisionalSchool"
					(provisionalSchoolChange)="onProvisionalSchoolChange($event)"></app-edit-provisional-school-information>
			</div>

			<div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6" [hidden]="!chosenSchool" #resolveTo>
				<h2>Resolve to this school</h2>

				<mat-card-content>
					<table class="table table-default">
						<tbody>
							<tr>
								<td class="table-label">Name</td>
								<td class="table-value">
									{{ chosenSchool?.NAME }}
								</td>
							</tr>

							<tr>
								<td class="table-label">School Type</td>
								<td class="table-value">
									<span>
										{{ chosenSchool?.SCHOOL_TYPE?.TYPE }}
									</span>

									<span *ngIf="
                    chosenSchool?.SCHOOL_TYPE?.TYPE &&
                    !chosenSchool?.SCHOOL_TYPE_OTHERS?.ID
                  ">
										(School Code - {{ chosenSchool?.SCHOOL_CODE }})
									</span>

									<span *ngIf="chosenSchool?.SCHOOL_TYPE_OTHERS?.ID">
										(
										{{ chosenSchool?.SCHOOL_TYPE_OTHERS?.TYPE }}
										-
										{{ chosenSchool?.SCHOOL_TYPE_OTHER }}
										)
									</span>
								</td>
							</tr>

							<tr>
								<td class="table-label">Region</td>
								<td class="table-value">
									{{ chosenSchool?.REGIONS?.NAME }}
									({{ chosenSchool?.REGIONS?.CODE }})
								</td>
							</tr>

							<tr>
								<td class="table-label">County</td>
								<td class="table-value">
									{{ chosenSchool?.COUNTy?.COUNTY_NAME }}
									({{ chosenSchool?.COUNTy?.COUNTY_CODE }})
								</td>
							</tr>

							<tr>
								<td class="table-label">School District</td>
								<td class="table-value">
									{{ chosenSchool?.SCHOOL_DISTRICT?.DISTRICTS }}
									({{ chosenSchool?.SCHOOL_DISTRICT?.CODE }})

									<span *ngIf="chosenSchool?.SCHOOL_DISTRICT?.NCESDist">
										(NCES - {{ chosenSchool?.SCHOOL_DISTRICT?.NCESDist }})
									</span>
								</td>
							</tr>

							<tr>
								<td class="table-label">Phone</td>
								<td class="table-value">
									<view-party-contact-mechanism-inline *ngIf="chosenSchool?.ORGANIZATION?.PARTy?.ID"
										[party]="chosenSchool?.ORGANIZATION?.PARTy" [category]="'Phone'" [inLine]="true"
										[disableRefresh]="true">
									</view-party-contact-mechanism-inline>
								</td>
							</tr>

							<tr>
								<td class="table-label">Address</td>
								<td class="table-value">
									<view-party-contact-mechanism-inline *ngIf="chosenSchool?.ORGANIZATION?.PARTy?.ID"
										[party]="chosenSchool?.ORGANIZATION?.PARTy" [category]="'Address'"
										[inLine]="true" [disableRefresh]="true">
									</view-party-contact-mechanism-inline>
								</td>
							</tr>
						</tbody>

						<tbody>
							<tr>
								<td class="table-label">SSID</td>
								<td class="table-value">{{ chosenSchool?.SSID }}</td>
							</tr>

							<tr>
								<td class="table-label">CDS Code</td>
								<td class="table-value">{{ chosenSchool?.cdscODE }}</td>
							</tr>

							<tr>
								<td class="table-label">School NCES</td>
								<td class="table-value">{{ chosenSchool?.SCHOOL_NCES }}</td>
							</tr>
						</tbody>

						<tbody>
							<tr>
								<td class="table-label">School Grade Span</td>
								<td class="table-value">
									<span *ngIf="chosenSchool?.LOW_GRADES">
										{{ chosenSchool?.LOW_GRADES?.DESCRIPTION }}
										({{ chosenSchool?.LOW_GRADES?.GRADES }})
										to
										{{ chosenSchool?.HIGH_GRADES?.DESCRIPTION }}
										({{ chosenSchool?.HIGH_GRADES?.GRADES }})
									</span>
								</td>
							</tr>

							<tr>
								<td class="table-label">School Status</td>
								<td class="table-value">
									{{ chosenSchool?.SCHOOL_STATUS_TYPES?.STATUS }}
								</td>
							</tr>

							<tr>
								<td class="table-label">School Property</td>
								<td class="table-value">
									{{ chosenSchool?.SCHOOL_PROPERTY_TYPES?.TYPE }}
								</td>
							</tr>

							<tr>
								<td class="table-label">Closed Date</td>
								<td class="table-value">
									{{ chosenSchool?.SCHOOL_STATUS?.CLOSE_DATE | cleanDate | simpleDate }}
								</td>
							</tr>
						</tbody>
					</table>

					<confirm-popover *ngIf="chosenSchool" class="margin-right-sm" [type]="'button'"
						[buttonTxt]="'Resolve to this school?'"
						[popoverMsg]="'Are you sure you want to resolve to this school?'" [color]="'primary'"
						(onConfirm)="resolveProvisionalSchool()" [disabled]="isResolving" [(isLoading)]="isResolving">
					</confirm-popover>

					<button mat-raised-button color="accent" (click)="reselectSchool()" [disabled]="isResolving">
						Reselect school
					</button>

					<app-msg [msg]="resolveMsg" *ngIf="resolveMsg && resolveMsg.MSG">
					</app-msg>
				</mat-card-content>
			</div>
		</div>


	</mat-card-content>

	<hr />

	<mat-card-content [hidden]="chosenSchool">
		<div class="row">
			<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
				<h2>
					Search and resolve {{provisionalSchool ? provisionalSchool.SCHOOL_NAME : ''}}
					<help-text-btn class="align-help-text-btn"
						[helpTextId]="'ResolveProvisionalSchool_SearchAndResolve'"></help-text-btn>
				</h2>
			</div>
		</div>

		<form [formGroup]="searchForm" (ngSubmit)="searchSchool()" class="form" novalidate>
			<div class="row">

				<!-- Basic Search -->
				<div class="col-md-6">
					<div class="panel panel-primary">
						<label>Search By</label>

						<div class="panel-body">
							<div class="row">

								<mat-form-field class="col-lg-6">
									<mat-label>
										School Name
									</mat-label>
									<input matInput id="schoolName" name="schoolName" type="string"
										formControlName="schoolName" placeholder="School Name (partial allowed)" />
								</mat-form-field>
								<mat-form-field class="col-lg-6">
									<mat-label>
										Address
									</mat-label>
									<input matInput id="schoolAddress" name="schoolAddress" type="string"
										formControlName="schoolAddress" placeholder="Number and/or Street" />
								</mat-form-field>

								<div class="col-lg-7">
									<div class="row">
										<label>CDS Code</label>

										<mat-form-field class="col-lg-3">
											<mat-label>
												XX
											</mat-label>
											<input matInput id="cdsCode1" name="cdsCode1" type="string"
												formControlName="cdsCode1" maxlength="2" />
										</mat-form-field>
										<mat-form-field class="col-lg-4">
											<mat-label>
												XXXXX
											</mat-label>
											<input matInput id="cdsCode2" name="cdsCode2" type="string"
												formControlName="cdsCode2" maxlength="5" />
										</mat-form-field>
										<mat-form-field class="col-lg-5">
											<mat-label>
												XXXXXXX
											</mat-label>
											<input matInput id="cdsCode3" name="cdsCode3" type="string"
												formControlName="cdsCode3" maxlength="7" />
										</mat-form-field>
									</div>
								</div>

								<div class="col-lg-5">
									<div class="row">
										<label>Search City</label>
										<mat-form-field class="col-lg-12">
											<mat-label>
												City
											</mat-label>
											<input matInput id="schoolCity" name="schoolCity" type="string"
												formControlName="schoolCity" placeholder="Search by City" />
										</mat-form-field>
									</div>
								</div>

							</div>
						</div>
					</div>
				</div>

				<!-- Location -->
				<div class="col-md-6">
					<div class="panel panel-info">
						<label>Location</label>

						<div class="panel-body">
							<div class="row">

								<div class="col-lg-12">
									<region-dropdown-two-way [isMultiple]="false" [(selectedRegions)]="chosenRegions"
										[reset]="resetField" #appRegionCode>
									</region-dropdown-two-way>

									<county-dropdown-two-way [isMultiple]="false" [(selectedCounties)]="chosenCounties"
										[reset]="resetField" #appCountyCode [regions]="chosenRegions">
									</county-dropdown-two-way>

									<district-dropdown-two-way [isMultiple]="false"
										[(selectedSchoolDistricts)]="chosenSchoolDistricts" [reset]="resetField"
										#appSchoolDistrictCode [regions]="chosenRegions" [counties]="chosenCounties">
									</district-dropdown-two-way>
								</div>

							</div>
						</div>
					</div>
				</div>

				<!-- Buttons -->
				<div class="col-12">
					<div class="btn-group">

						<button type="submit" mat-raised-button color="primary" mat-button
							[disabled]="!this.checkValid() || isSearching" class="margin-right-sm">
							<mat-icon *ngIf="isSearching">
								<mat-spinner diameter="18"> </mat-spinner>
							</mat-icon>
							Search
						</button>
						<button mat-raised-button color="accent" (click)="reset()" mat-button>Reset</button>

					</div>

					<app-msg [msg]="searchSchoolMsg"
						*ngIf="searchSchoolMsg && !searchSchoolMsg.SUCCESS && results.length === 0"></app-msg>
				</div>
			</div>
		</form>
	</mat-card-content>
	<mat-card-content [hidden]="chosenSchool">
		<div [hidden]="results.length === 0" class="margin-top-md scroll-margin" #res>
			<h2>
				Search Results - {{tableDataSources[0]?.filteredData?.length === schoolLength ? schoolLength :
				(tableDataSources[0]?.filteredData?.length + '/' + schoolLength)}} School(s)
			</h2>
			<hr />

			<div class="row gx-0">
				<mat-form-field class="col-lg-12">
					<mat-label>
						Filter
					</mat-label>
					<input matInput id="filter" name="filter" type="string" [(ngModel)]="filter"
						(ngModelChangeDebounced)="setFilter();" />
				</mat-form-field>
			</div>

			<div class="table-responsive">
				<mat-table [dataSource]="tableDataSources[0]" class="mat-elevation-z1" matSort>

					<ng-container matColumnDef="EDIT">
						<mat-header-cell *matHeaderCellDef> </mat-header-cell>
						<mat-cell *matCellDef="let element">
							<div>
								<button mat-icon-button color="primary" (click)="chooseSchool(element)"
									[disabled]="loadingSchool[element.ID.toString()]">
									<mat-icon [matTooltip]="'Resolve to this school'" [matTooltipPosition]="'above'"
										*ngIf="!loadingSchool[element.ID.toString()]">add_task</mat-icon>
									<mat-icon *ngIf="loadingSchool[element.ID.toString()]">
										<mat-spinner diameter="18"> </mat-spinner>
									</mat-icon>
								</button>
							</div>
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="REGIONS.CODE">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Region </mat-header-cell>
						<mat-cell *matCellDef="let element"> {{element.REGIONS.CODE}} </mat-cell>
					</ng-container>

					<ng-container matColumnDef="COUNTy.COUNTY_NAME">
						<mat-header-cell *matHeaderCellDef mat-sort-header> County </mat-header-cell>
						<mat-cell *matCellDef="let element">
							{{element.COUNTy.COUNTY_NAME}}
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="SCHOOL_DISTRICT.DISTRICTS">
						<mat-header-cell *matHeaderCellDef mat-sort-header> District </mat-header-cell>
						<mat-cell *matCellDef="let element"> {{element.SCHOOL_DISTRICT.DISTRICTS}}</mat-cell>
					</ng-container>

					<ng-container matColumnDef="NAME">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Name </mat-header-cell>
						<mat-cell *matCellDef="let element"> {{element.NAME}}</mat-cell>
					</ng-container>

					<ng-container
						matColumnDef="ORGANIZATION.PARTy.PARTY_CONTACT_MECHANISMS[0].CONTACT_MECHANISMS.POSTAL_ADDRESSES[0].STREET_1">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Address </mat-header-cell>
						<mat-cell *matCellDef="let element">
							<view-party-contact-mechanism-inline *ngIf="element?.ORGANIZATION?.PARTy?.ID"
								[party]="element?.ORGANIZATION?.PARTy" [category]="'Address'" [inLine]="true"
								[disableRefresh]="true">
							</view-party-contact-mechanism-inline>
						</mat-cell>
					</ng-container>

					<ng-container
						matColumnDef="ORGANIZATION.PARTy.PARTY_CONTACT_MECHANISMS[0].CONTACT_MECHANISMS.TELEPHONE_NUMBERS[0].PHONE_NUMBER">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Phone </mat-header-cell>
						<mat-cell *matCellDef="let element">
							<view-party-contact-mechanism-inline *ngIf="element?.ORGANIZATION?.PARTy?.ID"
								[party]="element?.ORGANIZATION?.PARTy" [category]="'Phone'" [inLine]="true"
								[disableRefresh]="true">
							</view-party-contact-mechanism-inline>
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="cdscODE">
						<mat-header-cell *matHeaderCellDef mat-sort-header> CDS Code </mat-header-cell>
						<mat-cell *matCellDef="let element">
							{{element.cdscODE}}
						</mat-cell>
					</ng-container>


					<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
					<mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
				</mat-table>
			</div>
			<mat-paginator #paginators
				[pageSizeOptions]="[5, 10, 20, (tableDataSources ? tableDataSources[0] ? tableDataSources[0].data.length > 100 ? tableDataSources[0].data.length : 100 : 100 : 100)]"
				showFirstLastButtons aria-label="Select page of periodic elements"
				[hidden]="tableDataSources[0]?.filteredData?.length === 0">
			</mat-paginator>
		</div>

	</mat-card-content>
</mat-card>